module.exports = __webpack_public_path__ + "static/media/sample2.36631916.svg";